import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FiPlusCircle, FiArrowLeft } from "react-icons/fi";
import { Link } from "react-router-dom";

const AddBlog = () => {
  const [newBlog, setNewBlog] = useState({
    title: "",
    content: "",
    author: "",
    featured_image: null,
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    setNewBlog({
      ...newBlog,
      [e.target.name]: e.target.value,
    });
  };

  const handleFileChange = (e) => {
    setNewBlog({
      ...newBlog,
      featured_image: e.target.files[0],
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new FormData();
    formData.append("title", newBlog.title);
    formData.append("content", newBlog.content);
    formData.append("author", newBlog.author);
    formData.append("featured_image", newBlog.featured_image);

    try {
      const response = await axios.post("https://3esolarventures.com/backend/add_blog.php", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("Blog added successfully:", response);
      navigate("/admin/blogs");
    } catch (error) {
      console.error("Error adding blog:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-h-screen flex items-center justify-center bg-gray-50 py-10 px-4">
      <div className="w-full max-w-3xl bg-white rounded-xl shadow-lg p-8">
        {/* Header */}
        <div className="flex justify-between items-center mb-8 border-b border-gray-200 pb-4">
          <h1 className="text-3xl font-bold text-gray-800">Create New Blog</h1>
          <Link
            to="/admin/blogs"
            className="flex items-center text-teal-600 hover:text-teal-500 transition-colors"
          >
            <FiArrowLeft className="mr-2" />
            <span>Back to Blogs</span>
          </Link>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Blog Title */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Title</label>
            <input
              type="text"
              name="title"
              required
              value={newBlog.title}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400 bg-gray-50 transition-colors"
            />
          </div>

          {/* Blog Content */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Content</label>
            <textarea
              name="content"
              required
              value={newBlog.content}
              onChange={handleChange}
              rows="6"
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400 bg-gray-50 resize-none transition-colors"
            ></textarea>
          </div>

          {/* Author */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Author</label>
            <input
              type="text"
              name="author"
              required
              value={newBlog.author}
              onChange={handleChange}
              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-400 bg-gray-50 transition-colors"
            />
          </div>

          {/* Image Upload */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Featured Image</label>
            <input
              type="file"
              name="featured_image"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full px-4 py-2 border border-gray-200 rounded-lg bg-gray-50 transition-colors"
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center space-x-2 bg-teal-600 text-white px-4 py-3 rounded-lg hover:bg-teal-700 transition-all disabled:opacity-50"
          >
            {loading ? (
              <div className="animate-spin h-5 w-5 border-4 border-white border-t-transparent rounded-full"></div>
            ) : (
              <>
                <FiPlusCircle className="w-5 h-5" />
                <span>Add Blog</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddBlog;
